// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or vendor/assets/javascripts of plugins, if any, can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file.
//

require("@rails/ujs").start()
global.Rails = Rails;
//require("turbolinks").start()

import { Turbo } from "@hotwired/turbo-rails"
// Drive handles full-page navigation; disable it globally so Turbo does not
// conflict with existing jQuery/Rails-UJS event handling on legacy pages.
// Turbo Frame navigation (used by DataTable pages) works independently of Drive.
Turbo.session.drive = false
//require("@rails/activestorage").start()
//require("channels")
//= require filterrific/filterrific-jquery

// Expose jQuery on window BEFORE loading any jQuery plugin. ES `import`
// statements are hoisted, so they would execute plugin code before these
// assignments run (breaking plugins that read window.jQuery / root.jQuery at
// load time). The plugins below are therefore loaded with require(), which is
// evaluated in source order, guaranteeing window.jQuery already exists.
const $ = require("jquery")
window.jQuery = $
window.$ = $

require("moment");
require("iframe-resizer")
require('./gradient-progress-bar') // this is necessary.
require('./jquery.validate')
require('./jstree')
require('./annuvia')
require('./role_exclusivity')
require('./bootstrap-3')
require('./bootstrap-multiselect')
require('./check')
//require('./jquery.fittext')
require('./jquery.rateit')
require('./jquery.typeahead')
require('./program_type_handler')
require('./pagy_per_page')
require('./address_verification')
// require('./bootstrap-clockpicker') - causes js errors in console

require("controllers")

require("trix")
require("@rails/actiontext")
require('../product_search_autocomplete')
